<template>
  <v-toolbar dense flat>
    <slot name="left"></slot>
    <v-tooltip bottom v-for="barAction of barActionGroup">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-on="on"
            small
            elevation="2"
            :color="barAction.color"
            dense
            class="mx-1"
            @click="onAction(barAction.dto_action_model)"
            :disabled="barAction.disabled ||
                      (barAction.show_only_saved && !!editedItem && editedItem.isDataChange) ||
                      (barAction.show_only_selected && !!selectedItems && selectedItems.length === 0)"

        >
          <v-icon :color="barAction.icon_color">{{ barAction.icon }}</v-icon>
          {{ barAction.label }}
        </v-btn>
      </template>
      <span v-if="!!barAction.text">{{ barAction.text }}</span>
      <span v-else>{{ barAction.label }}</span>
    </v-tooltip>
    <slot name="right"></slot>
  </v-toolbar>
</template>

<script>

export default {
  name: 'BaseBtnActionGroup',
  inheritAttrs: false,
  props: {
    barActionGroup: {default: null},
    editedItem: {default: null},
    selectedItems: {default: null},
    fetchAction: {default: null},
  },

  components: {},

  computed: {},

  methods: {
    onAction(dto_action_model) {
      console.log('onAction', this.editedItem, this.selectedItems, dto_action_model)
      let selected_uid_list = []
      this.selectedItems.forEach(row => selected_uid_list.push(row.uid))
      let editedItemUid = null
      if (!!this.editedItem)
        editedItemUid = this.editedItem.uid
      let dto_action = {
        current_uid: editedItemUid,
        selected_uid_list: selected_uid_list,
      }
      this.fetchAction({dto: dto_action, dto_action_model: dto_action_model})
    },
  },

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

